import React from "react";
import "./Header.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Avatar, Divider, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logout from "@mui/icons-material/Logout";

const Header: React.FC = () => {
  const currentUser = useSelector((state: RootState) => state.authVerification.currentUser);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  // Extract avatar letter logic to a variable
  let avatarLetter = "";
  if (currentUser?.firstName && currentUser?.lastName) {
    avatarLetter = currentUser.firstName.toUpperCase();
  } else if (currentUser?.email) {
    avatarLetter = currentUser.email.toUpperCase();
  }

  return (
    <div className="header-container">
      <div className="profile-container">
        <button className="profile not-a-button" onClick={handleClick}>
          <Avatar className="avatar">
            {avatarLetter?.[0]}
          </Avatar>
          <div className="user-name">
            {currentUser?.firstName
              ? `${currentUser.firstName} ${currentUser.lastName || ''}`
              : currentUser?.email ?? ''
            }
          </div>
        </button>
        <Menu
          disableAutoFocusItem={true}
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: "visible",
                mt: 1,
                background: "white",
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          classes={{
            paper: "menu-container"
          }}
        >
          <MenuItem
            disableRipple={true}
            classes={{
              root: "profile-menu"
            }}
          >

            <Avatar className="menu-avatar" sx={{ width: 48, height: 48, bgcolor: "#f6d396", color: "#000" }}>
              {currentUser?.firstName && currentUser?.lastName
                ? currentUser?.firstName[0].toUpperCase()
                : currentUser?.email?.[0]?.toUpperCase() ?? ""}
            </Avatar>
            <div className="menu-user-details">
              <div className="menu-user-name">
                {currentUser?.userName?.trim()
                  ? currentUser?.userName
                  : currentUser?.email?.trim()
                    ? currentUser?.email
                    : "Guest User"}
              </div>
              <div className="menu-email">{currentUser?.email}</div>
            </div>
          </MenuItem>
          <Divider
            sx={{
              border: "1px solid #2c2c2c",
              opacity: "10%"
            }}
          />
          <MenuItem
            onClick={handleLogout}
            classes={{
              root: "logout-menu"
            }}
          >
            <ListItemIcon sx={{ minWidth: "0px" }}>
              <Logout sx={{ width: "24px", height: "24px", fontSize: "14px", color: "#EF4444" }} />
            </ListItemIcon>
            <div className="logout-text">Sign Out</div>
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Header;
